import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';
import { Roles } from 'src/shared/enums';
import { Route } from '@angular/router';

export enum UtilityComponentIdentifier {
	UtilityJSFList = 'UtilityJSFList',
	UtilityJSFDetail = 'UtilityJSFDetail',
	UtilityJSFVmDetail = 'UtilityJSFVmDetail',
	UtilityCoverSheetList = 'UtilityCoverSheetList',
	UtilityCoverSheetDetail = 'UtilityCoverSheetDetail',
	UtilityCoverSheetVmDetail = 'UtilityCoverSheetVmDetail',
}

export interface UtilityRouteData {
	componentIdentifier: UtilityComponentIdentifier;
}

export interface UtilityRoute extends Route {
	data?: UtilityRouteData;
	children?: UtilityRoute[];
}

export const utilityFormsPaths = {
	default: '',
	root: 'utility-forms',
	utilityJobSetup: 'utility-job-setup',
	utilityJobSetupVm: 'utility-job-setup-vm',
	coverSheet: 'cover-sheet',
	coverSheetVm: 'cover-sheet-vm',
	list: 'list',
	detail: ':id',
};

export const utilityFragments = {
	default: [utilityFormsPaths.default],
	root: [utilityFormsPaths.default, utilityFormsPaths.root],
	jobSetup: [
		utilityFormsPaths.default,
		utilityFormsPaths.root,
		utilityFormsPaths.utilityJobSetup,
	],
	jobSetupList: [
		utilityFormsPaths.default,
		utilityFormsPaths.root,
		utilityFormsPaths.utilityJobSetup,
		utilityFormsPaths.list,
	],
	coverSheetList: [
		utilityFormsPaths.default,
		utilityFormsPaths.root,
		utilityFormsPaths.coverSheet,
		utilityFormsPaths.list,
	],
	jobSetupDetail: (id: number) => [
		utilityFormsPaths.default,
		utilityFormsPaths.root,
		utilityFormsPaths.utilityJobSetup,
		id,
	],
	jobSetupVmDetail: (id: number) => [
		utilityFormsPaths.default,
		utilityFormsPaths.root,
		utilityFormsPaths.utilityJobSetupVm,
		id,
	],
	coverSheetDetail: (id: number) => [
		utilityFormsPaths.default,
		utilityFormsPaths.root,
		utilityFormsPaths.coverSheet,
		id,
	],
	coverSheetVmDetail: (id: number) => [
		utilityFormsPaths.default,
		utilityFormsPaths.root,
		utilityFormsPaths.coverSheetVm,
		id,
	],
};

export const utilityDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
];

export const utilityDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: utilityDefaultAuthRoles },
};
